import React from 'react';
import { Colorway } from '@uds/theme-utils';
import { Layout } from 'domain/constants/layout';

import { getClassNames } from './Wash.stylesheet';

interface OuterProps {
  colorway: Colorway;
  layout: Layout;
  hasTiles: boolean | undefined;
  duoLayout: boolean | undefined;
}

export const Wash = ({ colorway, layout, duoLayout, hasTiles }: OuterProps) => {
  const classNames = getClassNames({ colorway, layout, duoLayout, hasTiles });

  return <div className={classNames.root} />;
};

Wash.displayName = 'Wash';

export default Wash;
